import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import { getRem } from './getRem';
export function getArrayRem(value) {
  if (!value) return null;
  return value.reduce(function (result, item) {
    return "".concat(result, " ").concat(getRem(item));
  }, '').toString().trim();
}
//# sourceMappingURL=getArrayRem.js.map